import { IPaymentProducts } from 'src/Utils/Hooks/Payments/useGetPaymentProducts';

/**
 * Calculates the maximum savings percentage between monthly and annual prices.
 * @param products - The payment products containing pricing information.
 * @returns The maximum savings percentage.
 */
export const calculateMaxSavings = (products: IPaymentProducts): number => {
    let maxSavings = 0;

    products.suiteProductComboInfos?.forEach((suite) => {
        const monthlyPrice = suite.monthlyInfo.price;
        const annualPrice = suite.yearlyInfo.price;

        // Calculate savings percentage
        const savings = ((monthlyPrice * 12 - annualPrice) / (monthlyPrice * 12)) * 100;

        // Update maxSavings if the current savings are higher
        if (savings > maxSavings) {
            maxSavings = savings;
        }
    });

    return Math.round(maxSavings); // Round to the nearest integer
};